import { Grid, Table, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import EventTile from './EventTile'
import { ScheduleTableDate, ScheduleTableEntry } from '../../types/schedule'
import { useTranslation } from 'react-i18next'
import Loader from '../common/Loader'
import { useMemo } from 'react'
import EmptyListPlaceholder from '../common/EmptyListPlaceholder'
import EmptyScheduleViewImage from '../../assets/images/emptyScheduleView.webp'

type Props = {
  data: ScheduleTableEntry[]
  dates: ScheduleTableDate[]
  hours: string[]
  loading: boolean
}

export default function ScheduleTable(props: Props) {
  const texts = useTranslation('schedule').t

  const isNoData = useMemo(() => 
    props.data.filter(hour => 
      hour.data.filter(day => day.data.length > 0).length > 0
    ).length === 0, 
  [props.data])

  return (
    <Table>
      <colgroup>
        <col style={{ width: '5%' }}/>
        {
          props.dates.map(_ => (
            <col style={{ width: `${95/props.dates.length}%` }}/>
          ))
        }
      </colgroup>
      <TableHead>
        <TableRow>
          <TableCell/>
          {
            props.dates.map(date => (
              <TableCell>
                <Grid
                  container
                  flexDirection='column'
                  alignItems='center'
                >
                  <Typography
                    variant='body1'
                    fontWeight={500}
                  >
                    {date.label}
                  </Typography>
                  <Typography
                    variant='body2'
                    fontWeight={300}
                  >
                    {texts('week_day_labels', { day: date.dayOfWeek }) }
                  </Typography>
                </Grid>
              </TableCell>
            ))
          }
        </TableRow>
      </TableHead>
      {
        props.data.map((row, idx) => (
          <TableRow>
            <TableCell 
              sx={{ 
                padding: '.5rem', 
                verticalAlign: 'top',
              }}
            >
              <Typography
                variant='body2'
                fontWeight={500}
              >
                {row.hour}
              </Typography>
            </TableCell>
            {
              props.loading && idx === 0 
              && <TableCell
                  rowSpan={props.hours.length}
                  colSpan={props.dates.length}
                >
                  <Loader />
                </TableCell>
            }
            {
              !props.loading && isNoData && idx === 0 
              && <TableCell
                  rowSpan={props.hours.length}
                  colSpan={props.dates.length}
                >
                  <EmptyListPlaceholder
                    image={EmptyScheduleViewImage}
                    title={texts('no_data_title')}
                    description={texts('no_data_description')}
                  />
                </TableCell>
            }
            {
              !props.loading && !isNoData && row.data.map(day => (
                <TableCell sx={{ padding: '.5rem', verticalAlign: 'top' }}>
                  <Grid
                    container
                    height='100%'
                    flexDirection='column'
                    alignItems='center'
                    gap='.5rem'
                  >
                    {day.data.map(e => <EventTile event={e}/>)}
                  </Grid>
                </TableCell>
              ))
            }
          </TableRow>
        ))
      }
    </Table>
  )
}

